import React, { useEffect, useState } from 'react';
import { makeApiRequest } from '../axiosService/apiCall';
import DataTable from 'react-data-table-component';

function ReferralStatus() {
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 5;
    const userData = async () => {
        try {
            let params = {
                url: `referred-user-status`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            // console.log("response--",response);
            
            if (response.status) {
                setData(response.referralDatas);
            } else {
                setData([]);
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    useEffect(() => {
        userData();
    }, []);


    const filteredData = data.filter(row =>
        row.referralEmail && row.referralEmail.trim() !== "" && row.referralEmail.toLowerCase().includes(searchQuery.toLowerCase()) ||
        row.userEmail && row.userEmail.trim() !== "" && row.userEmail.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const startIndex = (currentPage - 1) * perPage;
    const currentPageData = filteredData.slice(startIndex, startIndex + perPage);

    const formattedData = filteredData.map((row, index) => ({
        SNo: startIndex + index + 1,
        referralEmail: row.referralEmail || "-",
        userEmail: row.userEmail || "-",
    }));

    const columns = [
        {
            name: 'S.no',
            width: '300px',
            selector: row => row.SNo,
            sortable: true,
        },
        
        {
            name: 'Email',
            width: '300px',
            selector: (row) => row.userEmail,
            cell: (row) => <div className="no-wrap-cell">{row.userEmail}</div>,
        },
        {
            name: 'Referred Email',
            width: '300px',
            selector: (row) => row.referralEmail,
            cell: (row) => <div className="no-wrap-cell">{row.referralEmail}</div>,
        },
    ];

    const customSort = (rows, selector, direction) => {
        return rows.sort((a, b) => {
            const aField = selector(a).toLowerCase();
            const bField = selector(b).toLowerCase();
            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }
            return direction === 'desc' ? comparison * -1 : comparison;
        });
    };

    return (
        <div className='App'>
            <div className='container'>
                <div className="custom-saled-order text-dark ms-3">
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className="py-3 d-flex justify-content-between">
                                <h3 className="component-user">Referral Datas</h3>
                            </div>
                            <div className='row'>
                                <div className='col-lg-5'>
                                <input
                                    className="form-control form-search"
                                    type="text"
                                    placeholder="Search By Email "
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-lg-12'>
                                <div className='custom-datascroll'>
                                    <DataTable
                                        className="text-center "
                                        columns={columns}
                                        data={formattedData}
                                        pagination
                                        persistTableHead
                                        sortFunction={customSort}
                                        paginationPerPage={5}
                                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                    />
                                </div>


                            </div>
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        </div>
        </div >
    );
}

export default ReferralStatus;


